export default {
    UPDATE_PROPERTY_MODAL(state, data) {
        const { key, title, description, props } = data;
        const updateProperty = {};
        if (title) {
            updateProperty.title = title;
        }
        if (description) {
            updateProperty.description = description;
        }
        if (props) {
            updateProperty.props = props;
        }
        state.modalsSettings[key] = {
            ...state.modalsSettings[key],
            ...updateProperty,
        };
    },
    OPEN_MODAL(state) {
        state.showModal = true;
    },
    CLOSE_MODAL(state) {
        state.showModal = false;
    },
    SET_LAYOUT_MODAL(state, keyLayout) {
        state.modalLayout = keyLayout ? state.modalsSettings[keyLayout] : null;
    },
}